// /**
//  * Report Center Orders -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';

import jMoment from 'moment-jalaali';

type Props = {
  data: any;
  filtersValues: any;
  loading: any;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    // props.ordersDispatch({ ...props.filtersValues, size: 10000 })
  };
  const flattData = (data: any) => {
    let newData = [] as any;
    data?.centers.map(
      (item: {name: string; values: number[]; id: number}, index: number) => {
        newData[index] = {
          'نام مرکز': item.name,
          ...createObject(data.days, item.values),
        };
      }
    );
    return newData;
  };

  const createObject = (days: object[], values: number[]) => {
    return days.reduce(
      (o: any, key: any, index: number) => ({
        ...o,
        [jMoment(key, '').locale('fa').format(`jYYYY/jMM/jD`)]: values[index],
      }),
      {}
    );
  };

  return (
    <>
      {Object.keys(props.data).length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename={`Report-Current-Orders.csv`}
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود اکسل
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
